export enum ErrorCode {
  Authorization = "Authorization",
  Api = "Api",
  Brands = "Brands",
}
